export default __webpack_public_path__ + "static/media/04.072a6afd.png";